/** Shared Portal branding with the public Site's open-beta identification. */
export default function BrandLogo({ className = '', imageClassName = 'h-9' }: {
  className?: string;
  imageClassName?: string;
}) {
  return (
    <span className={`relative inline-flex shrink-0 items-center ${className}`}>
      <img
        src="/we-dohockey-orange-black-trans.png"
        alt="doHockey — open beta"
        className={`w-auto object-contain ${imageClassName}`}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-[6px] -top-1 whitespace-nowrap rounded-[3px] border border-[#f8d8c7] bg-[#fff6f0] px-1 py-[2px] text-[8px] font-bold uppercase leading-none tracking-[0.04em] text-[#9a391b]"
      >Open beta</span>
    </span>
  );
}
